module.exports = __webpack_public_path__ + "static/img/login_course_top.5df6ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_course_top.png
// module id = YVs7
// module chunks = 1